import { useCallback } from 'react';
import { useNavigate } from 'react-router';

import type { UserInfo } from '@/features/register/context/register.context';

import { useInterviewContext } from '@/features/common/contexts/interview.context';
import FormScreen from '@/features/register/pages/FormScreen';

import { useRegisterContext } from '../../contexts/register-context.ref';

export default function RegisterCguPage() {
  const navigate = useNavigate();
  const { onReset, handleBackToOnboardingWithReset } = useInterviewContext();
  const { registerInitialData, setRegisterInitialData } = useRegisterContext();

  const handleNext = useCallback(
    (partial?: Partial<UserInfo>) => {
      if (partial) setRegisterInitialData(prev => ({ ...prev, ...partial }));
      navigate('/register/names', { replace: true });
    },
    [navigate, setRegisterInitialData],
  );

  return (
    <FormScreen
      step="cgu"
      onNext={handleNext}
      onCancel={onReset}
      onBack={handleBackToOnboardingWithReset}
      initialData={registerInitialData}
    />
  );
}
